var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames);
    global.SubMenu = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SubMenu = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(SubMenu, _Component);

    var _super = _createSuper(SubMenu);

    function SubMenu() {
      var _this;

      (0, _classCallCheck2.default)(this, SubMenu);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (domElement) {
        _this.domElement = domElement;
      });
      return _this;
    }

    (0, _createClass2.default)(SubMenu, [{
      key: "render",
      value: function render() {
        var _this$props$subMenuSt = this.props.subMenuStyle,
            color = _this$props$subMenuSt.color,
            colorBg = _this$props$subMenuSt.colorBg;
        var isOpen = this.props.isOpen;
        return /*#__PURE__*/_react.default.createElement("ul", {
          className: (0, _classnames.default)('next-menu-submenu', {
            'is-open': isOpen
          }),
          ref: this.init,
          style: {
            backgroundColor: colorBg
          }
        }, this.props.links.map(function (link, index) {
          return /*#__PURE__*/_react.default.createElement("li", {
            className: "next-menu-submenu__item",
            key: "link-".concat(index)
          }, !link.subMenu && /*#__PURE__*/_react.default.createElement("a", {
            className: (0, _classnames.default)('next-menu-submenu__link', link.attr ? link.attr.class : ''),
            href: link.href,
            style: {
              color: color
            }
          }, link.label), link.subMenu && link.subMenu.map(function (subLink, subIndex) {
            return /*#__PURE__*/_react.default.createElement("a", {
              key: "sublink-".concat(index, "-").concat(subIndex),
              className: (0, _classnames.default)('next-menu-submenu__link', subLink.attr ? subLink.attr.class : ''),
              href: subLink.href,
              style: {
                color: color
              }
            }, subLink.label);
          }));
        }));
      }
    }]);
    return SubMenu;
  }(_react.Component);

  SubMenu.propTypes = {
    isOpen: _propTypes.default.bool.isRequired,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      href: _propTypes.default.string.isRequired,
      subMenu: _propTypes.default.arrayOf(_propTypes.default.shape({
        label: _propTypes.default.string.isRequired,
        href: _propTypes.default.string.isRequired
      }))
    })),
    subMenuStyle: _propTypes.default.shape({
      color: _propTypes.default.string,
      colorBg: _propTypes.default.string,
      colorHover: _propTypes.default.string
    })
  };
  var _default = SubMenu;
  _exports.default = _default;
});